import { render, staticRenderFns } from "./formatsList.vue?vue&type=template&id=dc969b82&"
import script from "./formatsList.vue?vue&type=script&lang=js&"
export * from "./formatsList.vue?vue&type=script&lang=js&"
import style0 from "./formatsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports